import { useTranslation } from 'react-i18next';

import './Spinner.styl';

type Props = { label?: string; fullscreen?: boolean };

export function Spinner({ label, fullscreen = false }: Props) {
  const { t } = useTranslation();
  return (
    <div className={fullscreen ? 'a-spinner a-spinner--fullscreen' : 'a-spinner'} role="status" aria-live="polite">
      <span className="a-spinner__ring" aria-hidden="true" />
      <span className="u-sr-only">{label ?? t('common.loading')}</span>
    </div>
  );
}
